import React from 'react'
import SelectBox from '../common/SelectBox'
import ProfileInput from '../common/ProfileInput'
import {
  presenceErrorClass,
} from 'servos/formValidations'

class IntPassport extends React.Component {
  render() {
    const {
      errors,
      id,
      selectedCountry,
      handleInput,
      handleCountryOfIssue,
      intPassportNumber,
    } = this.props

    return (
      <div className='w-50 ml-2 pl-3 pt-2 border-left border-green'>
        <div className='form-group'>
          <div className="row mt-2">
            <ProfileInput
              id={id}
              label='International passport number'
              value={intPassportNumber}
              handleInput={handleInput}
              errors={errors}
              className='col-12'
            />
          </div>
          <div className="row mt-2">
            <SelectBox
              label={'Country of issue'}
              selectedOption={gon.countries.names.filter( ({value}) => value == selectedCountry) }
              onChange={handleCountryOfIssue}
              options={gon.countries.names}
              errorMessage={errors['countryOfIssue']}
              className='col-12'
            />
          </div>
        </div>
      </div>
    )
  }
}

export default IntPassport;
